import React, { FC } from "react";
import style from "./style.module.scss";
import { IEinwohnergleichwertabfrageItemsResponse } from "../../store/slices/ewg";
import { divide, multiply, add, round } from "lodash";

interface IAdminEwgDetailInfoItem {
  title: string;
  items: IEinwohnergleichwertabfrageItemsResponse[];
}

const options: Record<string, { value: number; perItemQuantity: number }> = {
  "Krankenhäuser, Kliniken und ähnliche Einrichtungen": {
    value: 1,
    perItemQuantity: 1,
  },
  "öffentl. Verwaltungen, Geldinstitute, Verbände, Krankenkassen, Versicherungen, selbständig Tätige der freien Berufe, selbständige Handels-, Industrie- u. Versicherungs-Vertreterinnen oder -Vertreter":
    {
      value: 1,
      perItemQuantity: 3,
    },
  "Schulen, Kindergärten": {
    value: 1,
    perItemQuantity: 10,
  },
  "Speisewirtschaften, Imbissstuben": {
    value: 4,
    perItemQuantity: 1,
  },
  "Gaststättenbetriebe, die nur als Schankwirtschaft konzessioniert sind, Eisdielen":
    {
      value: 2,
      perItemQuantity: 1,
    },
  Beherbergungsbetriebe: {
    value: 1,
    perItemQuantity: 4,
  },
  "Lebensmitteleinzel- und Großhandel": {
    value: 2,
    perItemQuantity: 1,
  },
  "sonstige Einzel- u. Großhandel": {
    value: 0.5,
    perItemQuantity: 1,
  },
  "Industrie, Handwerk u. übrige Gewerbe": {
    value: 0.5,
    perItemQuantity: 1,
  },
};

const AdminEwgDetailInfoItem: FC<IAdminEwgDetailInfoItem> = ({
  title,
  items,
}) => {
  return (
    <div>
      <div className={style.title}>{title}</div>
      <div className={style.tableInfoWrapper}>
        <div
          className={style.rowWrapper}
          style={{
            borderBottom: !items.length ? "none" : "",
          }}
        >
          <div className={style.rowTitle}>Erfasster Unternehmensname</div>
          <div className={style.rowTitle}>Unternehmen/Institution</div>
          <div className={style.rowTitle}>je Platz/Beschäftigter/Bett</div>
          <div className={style.rowTitle}>Erfasste Anzahl</div>
          <div className={style.rowTitle}>Einwohnergleichwert</div>
          <div
            className={style.rowTitle}
            style={{
              borderRight: "none",
            }}
          >
            Mindest-Gefäßvolumen
          </div>
        </div>

        {items.map((el, idx) => {
          const item = options[el.facility];
          const isLast = idx === items.length - 1;
          const isEmployee = el.typeSpace === "Beschäftigte";

          return (
            <div
              className={isLast ? style.lastRowWrapper : style.rowWrapper}
              key={idx}
            >
              <div className={style.rowInfo}>{el.companyName}</div>
              <div className={style.rowInfo}>{el.facility}</div>
              <div className={style.rowInfo}>{el.typeSpace}</div>
              <div
                className={isEmployee ? style.employedRowInfo : style.rowInfo}
              >
                {isEmployee ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                    }}
                  >
                    <div
                      className={style.employedDataInfo}
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      <div>Anzahl Vollzeit-Beschäftigte:</div>{" "}
                      <div className={style.employedDataQuantity}>
                        {el.quantity}
                      </div>
                    </div>
                    <div
                      className={style.employedDataInfo}
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      <div>Anzahl Halbtags-Beschäftigte: </div>
                      <div className={style.employedDataQuantity}>
                        {el.quantityOfHalfDayEymployees}
                      </div>
                    </div>
                    <div
                      className={style.employedDataInfo}
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      <div>Anzahl Teilzeitbeschäftigte unter 50%: </div>
                      <div className={style.employedDataQuantity}>
                        {el.quantityOfPartTimeEmployees}
                      </div>
                    </div>
                    <div className={style.employedDataInfo}>
                      <div>Gesamtsumme: </div>
                      <div className={style.employedDataQuantity}>
                        {add(
                          +el.quantity,
                          add(
                            +el.quantityOfHalfDayEymployees,
                            +el.quantityOfPartTimeEmployees,
                          ),
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      color: !el.isQuantityPlausible ? "red" : "",
                    }}
                  >
                    {el.quantity}
                  </div>
                )}
              </div>
              <div className={style.rowInfo}>
                {isEmployee ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                    }}
                  >
                    <div
                      className={style.employedDataInfo}
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      <div className={style.employedDataQuantity}>
                        {el.quantity} / {item.perItemQuantity ?? 1} *{" "}
                        {item.value ?? 1} ={" "}
                        {round(
                          multiply(
                            divide(+el.quantity, item.perItemQuantity ?? 1),
                            item.value ?? 1,
                          ),
                          2,
                        )}
                      </div>
                    </div>
                    <div
                      className={style.employedDataInfo}
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      <div className={style.employedDataQuantity}>
                        ({el.quantityOfHalfDayEymployees} * 0.5) /{" "}
                        {item.perItemQuantity ?? 1} * {item.value ?? 1} ={" "}
                        {round(
                          multiply(
                            divide(
                              multiply(+el.quantityOfHalfDayEymployees, 0.5),
                              item.perItemQuantity ?? 1,
                            ),
                            item.value ?? 1,
                          ),
                          2,
                        )}
                      </div>
                    </div>
                    <div
                      className={style.employedDataInfo}
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      <div className={style.employedDataQuantity}>
                        ({el.quantityOfPartTimeEmployees} * 0.25) /{" "}
                        {item.perItemQuantity ?? 1} * {item.value ?? 1} ={" "}
                        {round(
                          multiply(
                            divide(
                              multiply(+el.quantityOfPartTimeEmployees, 0.25),
                              item.perItemQuantity ?? 1,
                            ),
                            item.value ?? 1,
                          ),
                          2,
                        )}
                        {/* {divide(
                          multiply(
                            item.value ?? 1,
                            +el.quantityOfPartTimeEmployees,
                          ),
                          4,
                        )} */}
                      </div>
                    </div>
                    <div
                      className={style.employedDataInfo}
                      style={{
                        justifyContent: "flex-start",
                        gap: "5px",
                      }}
                    >
                      <div>Gesamtsumme: </div>
                      <div className={style.employedDataQuantity}>
                        {round(
                          add(
                            multiply(
                              divide(+el.quantity, item.perItemQuantity ?? 1),
                              item.value ?? 1,
                            ),
                            add(
                              multiply(
                                divide(
                                  multiply(
                                    +el.quantityOfHalfDayEymployees,
                                    0.5,
                                  ),
                                  item.perItemQuantity ?? 1,
                                ),
                                item.value ?? 1,
                              ),
                              multiply(
                                divide(
                                  multiply(
                                    +el.quantityOfPartTimeEmployees,
                                    0.25,
                                  ),
                                  item.perItemQuantity ?? 1,
                                ),
                                item.value ?? 1,
                              ),
                            ),
                          ),
                          2,
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  // (item.value ?? 1)
                  `${el.quantity} / ${item.perItemQuantity ?? 1} * ${item.value ?? 1} = ${round(multiply(divide(+el.quantity, item.perItemQuantity ?? 1), item.value ?? 1), 2)}`
                )}
              </div>
              <div className={style.rowInfo}>
                {isEmployee ? (
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-around",
                    }}
                  >
                    <div
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      {multiply(
                        multiply(
                          divide(+el.quantity, item ? item.perItemQuantity : 1),
                          item ? item.value : 1,
                        ),
                        30,
                      )}
                    </div>
                    <div
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      {multiply(
                        multiply(
                          divide(
                            +el.quantityOfHalfDayEymployees,
                            item ? item.perItemQuantity : 1,
                          ),
                          divide(item ? item.value : 1, 2),
                        ),
                        30,
                      )}
                      {/* placeholder */}
                    </div>
                    <div
                      style={{
                        marginBottom: "8px",
                        color: !el.isQuantityPlausible ? "red" : "",
                      }}
                    >
                      {multiply(
                        multiply(
                          divide(
                            +el.quantityOfPartTimeEmployees,
                            item ? item.perItemQuantity : 1,
                          ),
                          divide(item ? item.value : 1, 4),
                        ),
                        30,
                      )}
                    </div>
                    <div
                      className={style.employedDataInfo}
                      style={{
                        justifyContent: "flex-start",
                        gap: "5px",
                      }}
                    >
                      <div>Gesamtsumme: </div>
                      <div className={style.employedDataQuantity}>
                        {round(
                          add(
                            multiply(
                              multiply(
                                divide(
                                  +el.quantity,
                                  item ? item.perItemQuantity : 1,
                                ),
                                item ? item.value : 1,
                              ),
                              30,
                            ),
                            add(
                              multiply(
                                multiply(
                                  divide(
                                    +el.quantityOfHalfDayEymployees,
                                    item ? item.perItemQuantity : 1,
                                  ),
                                  divide(item ? item.value : 1, 2),
                                ),
                                30,
                              ),
                              multiply(
                                multiply(
                                  divide(
                                    +el.quantityOfPartTimeEmployees,
                                    item ? item.perItemQuantity : 1,
                                  ),
                                  divide(item ? item.value : 1, 4),
                                ),
                                30,
                              ),
                            ),
                          ),
                          2,
                        )}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div
                    style={{
                      color: !el.isQuantityPlausible ? "red" : "",
                    }}
                  >
                    {multiply(
                      multiply(
                        divide(+el.quantity, item ? item.perItemQuantity : 1),
                        item ? item.value : 1,
                      ),
                      30,
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AdminEwgDetailInfoItem;
